import { render } from "./TyreClaim.vue?vue&type=template&id=ee339336&scoped=true"
import script from "./TyreClaim.vue?vue&type=script&lang=js"
export * from "./TyreClaim.vue?vue&type=script&lang=js"

import "./TyreClaim.vue?vue&type=style&index=0&id=ee339336&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee339336"]])

export default __exports__